import { requestPost } from '@/utils/axios.js'
export const languageList = (params) => {
  return requestPost('/passport/v1/public/language/list', params, { loading: false })
}
